<template>
  <v-container>
    <div class="tableTitle">時間</div>
    <div class="tableSubTitle">平日</div>
    <table>
      <tr>
        <th>平日総労働時間</th>
        <td>{{ toFormattedTime(timeCounts.work) }}</td>
      </tr>
      <tr>
        <th>うち深夜勤務時間</th>
        <td>{{ toFormattedTime(timeCounts.lateNight) }}</td>
      </tr>
      <tr>
        <th>有給休暇加算時間</th>
        <td>{{ toFormattedTime(timeCounts.paidDayOff) }}</td>
      </tr>
      <tr>
        <th>無休特別休暇時間</th>
        <td>{{ toFormattedTime(timeCounts.noPaidDayOff) }}</td>
      </tr>
      <tr>
        <th>所定労働時間</th>
        <td>{{ toFormattedTime(timeCounts.monthly_predefined) }}</td>
      </tr>
      <tr>
        <th>超過勤務時間</th>
        <td>
          {{
            timeCounts.diffrence_monthly_predefined_and_work > 0
              ? toFormattedTime(0)
              : toFormattedTime(
                  -1 * timeCounts.diffrence_monthly_predefined_and_work
                )
          }}
        </td>
      </tr>
      <tr v-if="owner.few_work_days || owner.few_work_hours">
        <th>法定労働時時間</th>
        <td>{{ toFormattedTime(timeCounts.monthly_worktime_by_law) }}</td>
      </tr>
      <tr v-if="owner.few_work_days || owner.few_work_hours">
        <th>法定内超過勤務時間</th>
        <td>{{ toFormattedTime(getWorkingHoursWithinLaw()) }}</td>
      </tr>
      <tr v-if="owner.few_work_days || owner.few_work_hours">
        <th>法定外超過勤務時間</th>
        <td>{{ toFormattedTime(timeCounts.overtime_by_law) }}</td>
      </tr>
      <tr>
        <th>不足時間</th>
        <td>
          {{
            timeCounts.diffrence_monthly_predefined_and_work > 0
              ? toFormattedTime(
                  timeCounts.diffrence_monthly_predefined_and_work
                )
              : toFormattedTime(0)
          }}
        </td>
      </tr>
    </table>
    <div class="tableSubTitle">休日</div>
    <table>
      <tr>
        <th>休日総労働時間</th>
        <td>{{ toFormattedTime(timeCounts.holidayWork) }}</td>
      </tr>
      <tr>
        <th>うち深夜勤務時間</th>
        <td>{{ toFormattedTime(timeCounts.holidayLateNight) }}</td>
      </tr>
    </table>
  </v-container>
</template>
<script>
import { unixtimeToFormattedLargeTime } from "@/utils/datetime.js";
import { calcWorkingHoursWithinLaw } from "@/utils/timeCount.js";
import { mapGetters } from "vuex";
export default {
  data: () => ({}),
  props: {},
  computed: {
    ...mapGetters("timesheet", ["timeCounts", "owner"]),
  },
  created() {},
  mounted() {},
  methods: {
    toFormattedTime(unixtime) {
      return unixtimeToFormattedLargeTime(unixtime);
    },
    getWorkingHoursWithinLaw() {
      return calcWorkingHoursWithinLaw(this.timeCounts);
    },
  },
};
</script>
<style lang="scss" scoped>
.tableTitle {
  font-size: 16px;
  color: #ff5722;
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
  margin: 10px;
}
.tableTitle:before {
  content: "";
  background-color: #ff5722;
  display: inline-block;
  height: 15px;
  margin-right: 10px;
  position: relative;
  top: 2px;
  width: 15px;
}
table {
  margin: 10px;
  border: solid 1px;
  border-collapse: collapse;
}
th {
  text-align: left;
}
th,
td {
  border: solid 1px;
  padding: 5px 10px;
}
td {
  text-align: right;
}
.tableSubTitle {
  font-size: 14px;
  color: #616161;
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
  margin: 10px;
}
</style>

